import FooterShipping from "components/Profiles/SettingShipping/FooterShippong";
import ProductLayout from "layouts/ProductLayout";
import SettingShipping from "components/Profiles/SettingShipping";
import React from "react";

const SettingShippingPage = () => {
  return (
    <>
      <ProductLayout namePage="จัดการค่าจัดส่ง" footerComponent={<FooterShipping/>}>
        <div className="layout-content">
            <SettingShipping />
        </div>
      </ProductLayout>
    </>
  );
};

export default SettingShippingPage;
